/**
 * #53: Aktueller Queue-Besitzer (user.id aus /auth/me).
 *
 * Die IndexedDB-Queues (opQueue/photoQueue) liegen pro Browser-Origin --
 * auf einem geteilten Lagergerät dürfen Einträge nur unter der Sitzung
 * ihres Erstellers angezeigt und versendet werden. AuthContext pflegt den
 * Wert bei Login, Session-Refresh und Logout; null = abgemeldet, dann
 * versendet kein Worker etwas.
 */

let _userId = null;

export function setQueueUser(userId) {
    _userId = userId || null;
}

export function getQueueUser() {
    return _userId;
}

/**
 * Gehört der Eintrag dem angemeldeten Nutzer? Alt-Einträge (vor #53)
 * tragen keine userId und gehören dem gerade angemeldeten Nutzer --
 * sonst wären sie für immer unsichtbar und würden nie versendet; die
 * Sync-Pässe stempeln sie beim ersten Kontakt um.
 */
export function ownsEntry(rec) {
    return !!_userId && (!rec.userId || rec.userId === _userId);
}
